import { Music } from '@/pages/Event/components/Music';

type MusicTabProps = {
  organizationPermissions?: string[];
};

export const MusicTab = ({ organizationPermissions }: MusicTabProps) => {
  return (
    <div className='no-scrollbar flex w-full flex-col justify-center overflow-auto pt-9 md:px-20'>
      <Music isTab={true} organizationPermissions={organizationPermissions} />
    </div>
  );
};
